/// <amd-module name="SuiteCommerce.GiftCertificate.LandingPage.Router"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.LandingPage.Router", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.ValueCheck.Model", "SuiteCommerce.GiftCertificate.LandingPage.Configuration", "SuiteCommerce.GiftCertificate.LandingPage.View"], function (require, exports, Backbone_1, ValueCheck_Model_1, LandingPage_Configuration_1, LandingPage_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LandingPageRouter = void 0;
    var LandingPageRouter = /** @class */ (function (_super) {
        __extends(LandingPageRouter, _super);
        function LandingPageRouter(options) {
            var _this = _super.call(this, options) || this;
            _this.application = options.application;
            _this.model = new ValueCheck_Model_1.ValueCheckModel({});
            return _this;
        }
        Object.defineProperty(LandingPageRouter.prototype, "routes", {
            get: function () {
                var dynamicRouteObj = {};
                dynamicRouteObj[this.getFormUrl()] = 'showGiftCertificateMain';
                return dynamicRouteObj;
            },
            enumerable: false,
            configurable: true
        });
        LandingPageRouter.prototype.getFormUrl = function () {
            return LandingPage_Configuration_1.LandingPageConfiguration.landingPageRoute;
        };
        LandingPageRouter.prototype.getResultUrl = function () {
            return "".concat(this.getFormUrl(), "/result");
        };
        LandingPageRouter.prototype.showGiftCertificateMain = function () {
            var view = new LandingPage_View_1.LandingPageView({
                application: this.application,
                container: this.application,
                model: this.model,
            });
            view.showContent();
        };
        return LandingPageRouter;
    }(Backbone_1.Router));
    exports.LandingPageRouter = LandingPageRouter;
});
